// GSAP
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/src/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// Timeline init
let corporate_slider_scroll_tl = gsap.timeline( { defaults: { repeat: 0, duration: 0.5 } } );
let corporate_slider_tl = gsap.timeline( { defaults: { repeat: 0, duration: 2 } } );
if( $('body').hasClass('who-we-are-page') ) {
    // Tween 1: Title fade-in up
    corporate_slider_scroll_tl.from( 
        $('#corporate h2'), 
        {
            // scrollTrigger: {
            //     trigger: '#corporate',
            //     start: "0% 80%",
            //     end: "0% 50%",
            //     scrub: 2,
            // },
            y: 100,
            ease: 'back.out(1.1)'
        },
    );
    // Tween 2: Cards fade-in up
    corporate_slider_scroll_tl.from( 
    $('#corporate .card'), 
    {
        // scrollTrigger: {
        //     trigger: '#corporate .card',
        //     start: "0% 100%",
        //     end: "80% 80%",
        //     scrub: 2,
        // },
        autoAlpha: 0,
        stagger: 0.1,
        // duration: 0.5,
        x: 100,
        ease: 'back.out(1.2)',
    },
    
    );





    // // On slider init
    // $('#popular-tests-slider').on('init', function (event, slick, direction) {
    //     popular_test_scroll_tl.play(true);
    // });
    // // On slider before change
    // $('#popular-tests-slider').on('beforeChange', function (slick, currentSlide, nextSlide) {
    //   setTimeout(() => {
    //     popular_test_scroll_tl.play(false);
    //     popular_test_scroll_tl.seek(0);
    //   }, 0);
    // });
    // // On slider after change
    // $('#popular-tests-slider').on('afterChange', function (slick, currentSlide) {
    //   setTimeout(() => {
    //     popular_test_scroll_tl.play(true);
    //   }, 500);
    // });
}